"use strict";

angular.module("core")
.component("inventoryQuantityFilter", {
    templateUrl: require("./inventory-quantity-filter.component.html"),
    controllerAs: "inventoryQuantityFilterCtrl",
    controller: function($scope, $stateParams) {
        var _this = this;
        this.inventory_quantity_min = parseObjectQuantity($stateParams, 'inventory_quantity_min');
        this.inventory_quantity_max = parseObjectQuantity($stateParams, 'inventory_quantity_max');
        
        this.updateFilter = function() {
            $scope.$emit("inventoryQuantityFilterUpdated", {
                inventory_quantity_min: parseObjectQuantity(_this, 'inventory_quantity_min'),
                inventory_quantity_max: parseObjectQuantity(_this, 'inventory_quantity_max')
            });
        };

        function parseObjectQuantity(object, attribute) {
            if (typeof object[attribute] === "string") {
                return parseInt(object[attribute]);
            }
            return object[attribute];
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/inventory-quantity-filter/inventory-quantity-filter.component.js
// module id = 602
// module chunks = 0